import api from "../../api";
import { formatArrayToElSelect } from "./../../utils";

const state = {
  status: "",
  list: [],
  requestTypes: []
};

const getters = {
  status: (state) => state.status,
  list: (state) => state.list,
  list_to_select: (state) => {
    let b = [];

    state.list.forEach((item) => {
      b.push({
        label: item.Description,
        value: item.Id,
        IsEnabled: item.IsEnabled
      });
    });

    return b;
  },
  getInternalRequestTypesSelector: (state) => {
    return formatArrayToElSelect(
      state.requestTypes.filter((f) => f.IsInternal),
      {
        label: "Description",
        value: "Id"
      }
    );
  },
  getExternalRequestTypesSelector: (state) => {
    return formatArrayToElSelect(
      state.requestTypes.filter((f) => !f.IsInternal),
      {
        label: "Description",
        value: "Id"
      }
    );
  }
};

const actions = {
  all: ({ commit }) => {
    return new Promise((resolve, reject) => {
      commit("loading");

      api
        .get("/api/serviceRequestTypes")
        .then((resp) => {
          //console.log(resp);
          commit("success");
          commit(
            "list",
            resp.data.Items.filter(
              (f) => f.IsInternal !== null && !f.IsInternal
            )
          );
          resolve(resp);
        })
        .catch((err) => {
          commit("error");
          reject(err);
        });
    });
  },
  internal: ({ commit }) => {
    return new Promise((resolve, reject) => {
      commit("loading");

      api
        .get("/api/serviceRequestTypes")
        .then((resp) => {
          //console.log(resp);
          commit("success");
          commit(
            "list",
            resp.data.Items.filter((f) => f.IsInternal !== null && f.IsInternal)
          );
          resolve(resp);
        })
        .catch((err) => {
          commit("error");
          reject(err);
        });
    });
  },
  create: ({ commit }, request) => {
    return new Promise((resolve, reject) => {
      commit("loading");

      api
        .post("/api/serviceRequests/add", request)
        .then((resp) => {
          commit("success");
          resolve(resp);
        })
        .catch((err) => {
          commit("error");
          reject(err);
        });
    });
  },
  fetchRequesTypes: ({ commit }) => {
    return new Promise((resolve, reject) => {
      commit("loading");

      api
        .get("/api/serviceRequestTypes", {
          timeout: 3000 * 6 * 1000
        })
        .then((resp) => {
          commit("success");
          commit("SET_REQUEST_TYPES", resp.data.Items);
        })
        .catch((err) => {
          console.error(err);
          commit("error");
          reject(err);
        });
    });
  }
};

const mutations = {
  success: (state) => {
    state.status = "success";
  },
  loading: (state) => {
    state.status = "loading";
  },
  error: (state) => {
    state.status = "error";
  },
  list: (state, data) => {
    state.list = data;
  },
  SET_REQUEST_TYPES: (state, payload) => {
    state.requestTypes = payload;
  }
};

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
};
